<template>
  <div class="footMain" style="text-align:center">
    <p>
      <a href="/main/about.htm">关于我们</a>
      |
      <a href="/main/copyright.htm">版权声明</a>
      |
      <a href="/main/lineService.htm">在线客服</a>
      |
      <a href="/main/help.htm">常见问题</a>
      |
      <a href="/main/readme.htm">积分说明</a>
      |
      <a href="/main/partnership.htm">商务合作</a>
      |
      <a href="/main/contact.htm">联系我们</a>
    </p>
    <p>
      <a href="https://beian.miit.gov.cn" target="_blank">京ICP备14027621号-3</a> 京网文(2021)2508-690号 增值电信业务经营许可证京ICP证150810号
    </p>
    <p>
      © 2018
      <span>中文在线</span> 书香中国为中文在线旗下网站未经许可严禁转载
    </p>
  </div>
</template>

<script>
export default {
  name: "footer",
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$fontColor:"#333"; 
.footMain{
  color:$fontColor;
  font-size: 0.20rem;
  height: 3.6rem;
  padding-top:0.78rem ;
  a{
      color: $fontColor;
  font-size: 0.20rem;
  }
  p{
    line-height: 0.4rem;
  }
}
</style>
